// Global
import React, { JSX } from 'react';
import { tv } from 'tailwind-variants';

// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import { ComponentProps } from 'lib/component-props';
import { CheckboxParamType } from 'lib/component-props/rendering-param-types';
import { AccordionContextProvider } from 'helpers/Context/AccordionContext';
import { findComponent } from 'lib/utils/object-utils';
import { AccordionItemProps } from './AccordionItem';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';

export type AccordionProps = ComponentProps & {
  params: {
    singleOpenPanel?: CheckboxParamType;
    scrollToOpenPanel?: CheckboxParamType;
    openByDefault?: CheckboxParamType;
  };
};

const Accordion = (props: AccordionProps): JSX.Element => {
  const { DynamicPlaceholderId, RenderingIdentifier } = props?.params || {};

  const phKey = `accordion-${DynamicPlaceholderId}`;

  /*
   * Rendering
   */

  const { base } = TAILWIND_VARIANTS();

  const accordionItems = findComponent<AccordionItemProps['rendering']>(
    props.rendering,
    'AccordionItem'
  );

  const singlePanelOpen = props.params.singleOpenPanel === '1';

  const scrollToOpenPanel = props.params.scrollToOpenPanel === '1';

  const defaultOpenPanels: AccordionItemProps['rendering'][] = [];

  if (props.params.openByDefault === '1') {
    if (singlePanelOpen) {
      defaultOpenPanels.push(accordionItems[0]);
    } else {
      defaultOpenPanels.push(...accordionItems);
    }
  }

  return (
    <section
      className={base()}
      data-component="authorable/shared/lists/accordion"
      id={RenderingIdentifier}
    >
      <div className="max-w-screen-xxl mx-10 lg:mx-auto px-0 lg:px-20">
        <AccordionContextProvider
          panels={accordionItems}
          singleOpenPanel={singlePanelOpen}
          scrollToOpenPanel={scrollToOpenPanel}
          defaultOpenPanels={defaultOpenPanels}
        >
          <PlaceholderWrapper name={phKey} rendering={props.rendering} />
        </AccordionContextProvider>
      </div>
    </section>
  );
};

export const Default = withStandardComponentWrapper(Accordion, false);

const TAILWIND_VARIANTS = tv({
  slots: {
    base: ['component'],
  },
});
